<template>
    <div>
        <nav id="header" class="navbar navbar-expand-lg navbar-light fixed-top bgcolor bgcolor-2">

            <div class="container" >
                <router-link class="navbar-brand p-3" :to="{ name: 'Main' }"style=" margin-top: 30px;">
                    <img src="https://ausa.com.mx/img/Ausa-white.png" alt="" id="logo" height="100"
                        class="logo-mobile" /></router-link>
                <!-- 
                                    <a class="navbar-brand p-3" href="#" id="logo-heager">
                </a> -->
                <router-link class="navbar-brand" :to="{ name: 'Main' }" style=" margin-top: -2px;">
                    <!-- <a class="navbar-brand p-3" href="#" id="logo-heager"> -->
                    <img src="https://www.ausa.com.mx/img/Ausa-logov5.PNG" alt="" id="logo" height="75"
                        class="logo-interiores no-mostrar" />
                </router-link>
                <!-- </a> -->
                <button class="navbar-toggler" v-on:click="openNav()" type="button" data-toggle="collapse"
                    data-target="#navbarText" aria-controls="navbarText" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <i id="boton-header" class="fas fa-bars"></i>
                </button>
                <div class="collapse navbar-collapse" id="navbarText">
                    <ul class="navbar-nav ml-auto" id="menu">
                        <li class="nav-item nav-item-color" data-url="formamos-lideres">
                            <router-link class="nav-link" id="homeLink" :to="{ name: 'Main' }">Home</router-link>
                        </li>
                        <li class="nav-item nav-item-color" data-url="catalogo-empresas-home">
                            <router-link class="nav-link" id="nosotrosLink"
                                :to="{ name: 'Nosotros' }">NOSOTROS</router-link>
                        </li>
                        <li class="nav-item nav-item-color" data-url="lideres-section">
                            <router-link class="nav-link" id="serviciosLink"
                                :to="{ name: 'Servicios' }">SERVICIOS</router-link>
                        </li>
                        <li class="nav-item nav-item-color" data-url="vendedor-section">
                            <router-link class="nav-link" id="clientesLink"
                                :to="{ name: 'Clientes' }">CLIENTES</router-link>
                        </li>
                        <li class="nav-item nav-item-color" data-url="talent">
                            <router-link class="nav-link" id="contanctoLink"
                                :to="{ name: 'Contacto' }">CONTACTO</router-link>
                        </li>
                        <li class="nav-item dropdown" v-on:click="dropDownMenu()">
                            <a class="nav-link dropdown-toggle no-border boton-acceso" id="navbarDropdown" role="button"
                                data-toggle="dropdown">
                                ACCESO
                            </a>
                            <ul class="dropdown-menu" id="dropDownItems" aria-labelledby="navbarDropdown">
                                <li>
                                    <a class="dropdown-item textos parrafos-secundarios bold azulFuerte mayus"
                                        target="_blank" href="https://www.ausa.com.mx/PrusiaPlus">Abogados</a>
                                </li>
                                <li>
                                    <a class="dropdown-item textos parrafos-secundarios bold azulFuerte mayus"
                                        target="_blank" href="https://www.ausa.com.mx/Siniestros">Siniestros</a>
                                </li>
                                <li>
                                    <a class="dropdown-item textos parrafos-secundarios bold azulFuerte mayus"
                                        target="_blank" href="https://www.ausa.com.mx/provNet">Proveedores</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <span class="navbar-text">
                    </span>
                </div>
            </div>
            <div id="mySidenav" class="sidenav">
                <a href="javascript:void(0)" class="closebtn" v-on:click="closeNav()">&times;</a>
                <router-link to="/" class="textos  bold azulFuerte mayus">HOME</router-link>
                <router-link :to="{ name: 'Nosotros' }" class="textos bold azulFuerte mayus">NOSOTROS</router-link>
                <router-link :to="{ name: 'Servicios' }" class="textos bold azulFuerte mayus">SERVICIOS</router-link>
                <router-link :to="{ name: 'Clientes' }" class="textos bold azulFuerte mayus">CLIENTES</router-link>
                <router-link :to="{ name: 'Contacto' }" class="textos bold azulFuerte mayus">CONTACTO</router-link>

                <a class="dropdown-toggle no-border textos bold azulFuerte mayus" role="button"
                    v-on:click="dropDownMobile()">
                    ACCESO
                </a>
                <ul id="accesoMobile" class="hideContent" style="list-style: none; padding: 0 15px 0 0 ; ">
                    <li>
                        <a class="dropdown-item textos parrafos-secundarios  azulFuerte mayus"
                            v-on:click="dropDownMobile()" target="_blank"
                            href="https://www.ausa.com.mx/PrusiaPlus">Abogados</a>
                    </li>
                    <li>
                        <a class="dropdown-item textos parrafos-secundarios  azulFuerte mayus"
                            v-on:click="dropDownMobile()" target="_blank"
                            href="https://www.ausa.com.mx/Siniestros">Siniestros</a>
                    </li>
                    <li>
                        <a class="dropdown-item textos parrafos-secundarios  azulFuerte mayus"
                            v-on:click="dropDownMobile()" target="_blank"
                            href="https://www.ausa.com.mx/provNet">Proveedores</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>
<style scoped>
/* @import "@/assets/template/css/HSectionNum.css";
    @import "@/assets/template/css/Home.css";
    @import "@/assets/template/css/HomaMedia.css";
    @import "@/assets/template/css/textosF.css";
    @import "@/assets/template/css/Icons.css";
    @import "@/assets/template/css/HSectionFrase.css";
    @import "@/assets/template/css/HSectionMap.css";
    @import "@/assets/template/css/NavMenu.css";
    @import "@/assets/template/css/NavMenuMedia.css";
    @import "@/assets/template/css/generals.css"; */
@import "../../../assets/template/css/NavMenu.css";
@import "../../../assets/template/css/NavMenuMedia.css";
@import "../../../assets/template/css/textosF.css";

#header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0;
    z-index: 10000;
    transition: all .2s ease-in-out;
    height: 80px;
    background-color: transparent;
    text-align: center;
    line-height: 40px;
}

.container {
    width: 90%;
}

.hideContent {
    display: none;
}

.showContent {
    display: block;
}

.sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
    background-color: #ebf5fa;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 60px;
}

.sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 25px;
    color: #002551 !important;
    display: block;
    transition: 0.3s;
}

.sidenav a:hover {
    color: #f1f1f1;
}

.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

@media screen and (max-height: 450px) {
    .sidenav {
        padding-top: 15px;
    }

    .sidenav a {
        font-size: 18px;
    }
}

.active-link {
    color: #cd292a !important;
}
</style>
<script>

window.onclick = function (event) {
    if (!event.target.matches('.dropdown-toggle')) {
        var dropdowns = document.getElementsByClassName("dropdown-menu");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
};


export default {
    name: 'MyComponent',
    data() {
        return {
            mobileDropD: false,

        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.setActiveMenu();
    },
    methods: {
        setActiveMenu() {
            let activeLink = window.location.href;
            let domainN = window.location.hostname == "localhost" ? 'http://localhost:55475' : 'https://www.ausa.com.mx';
            var listLinks;
            listLinks = document.querySelectorAll(".nav-item");
            for (var i = 0; i < listLinks.length; ++i) {
                listLinks[i].classList.remove('active-link');
            }

            switch (activeLink) {
                case domainN + "/":
                    document.querySelector("#homeLink").classList.add("active-link");
                    break;
                case domainN + "/Nosotros":
                    document.querySelector("#nosotrosLink").classList.add("active-link");
                    break;
                case domainN + "/Servicios":
                    document.querySelector("#serviciosLink").classList.add("active-link");
                    break;
                case domainN + "/ClientesAusa":
                    document.querySelector("#clientesLink").classList.add("active-link");
                    break;
                case domainN + "/Contacto":
                    document.querySelector("#contanctoLink").classList.add("active-link");
                    break;
            }
        },

        dropDownMobile() {
            this.mobileDropD = !this.mobileDropD;
            if (this.mobileDropD == true) {
                document.getElementById("accesoMobile").classList.remove("hideContent");
                document.getElementById("accesoMobile").classList.add("showContent");
            } else {
                document.getElementById("accesoMobile").classList.add("hideContent");
                document.getElementById("accesoMobile").classList.remove("showContent");
            }
        },

        dropDownMenu() {
            document.getElementById("dropDownItems").classList.toggle("show");
        },

        openNav() {
            document.getElementById("mySidenav").style.width = "250px";
        },

        closeNav() {
            document.getElementById("mySidenav").style.width = "0";
        },

        handleScroll(event) {
            // Any code to be executed when the window is scrolled
            if (window.scrollY > 50) {
                document.querySelector("#header").classList.add("active");
                document.querySelector(".nav-item").classList.remove("nav-item-color");
                document.querySelector('.nav-link').classList.add('active');
                document.querySelector('.logo-interiores').classList.add('no-mostrar');
                document.querySelector('.logo-mobile').classList.add('no-mostrar');
                document.querySelector('.logo-interiores').classList.remove('no-mostrar');


                var list;
                list = document.querySelectorAll(".nav-link");
                for (var i = 0; i < list.length; ++i) {
                    list[i].classList.add('color-dakr');
                }
                document.querySelector('#boton-header').classList.add('color-dakr');
                document.querySelector('.fas').classList.add('fa-bars2');

                //console.log("Just Scrolled To: ", window.scrollY);
            } else {
                document.querySelector("#header").classList.remove("active");
                document.querySelector('.nav-link').classList.remove('estilo-borde');
                document.querySelector(".nav-item ").classList.add("nav-item-color");
                document.querySelector('.logo-interiores').classList.add('no-mostrar');

                var list;
                list = document.querySelectorAll(".nav-link");
                for (var i = 0; i < list.length; ++i) {
                    list[i].classList.remove('color-dakr');
                }
                document.querySelector('#boton-header').classList.remove('color-dakr');
                //document.querySelector('.nav-link').classList.remove('color-dakr');

                document.querySelector('.logo-mobile').classList.remove('no-mostrar');
                document.querySelector('.fas').classList.remove('fa-bars2');

                //console.log("Back To Top!");
            }

        }

    },

    watch: {

    }
}
</script>
